import { VenueNameDisplay } from 'src/components/Events/EventInfo';
import { TableCellDiv } from 'src/core/ui/TableCellDiv';
import * as styles from 'src/tables/Table/Table.css';
import { getDescription } from 'src/utils/eventWithDataUtils';
import {
  Event,
  Performer,
  TopLevelCategory,
  Venue,
} from 'src/WebApiController';

type LocationDisplayCellProps = {
  event: Event;
  performer?: Performer;
  venue?: Venue;
  isSinglePerformerView?: boolean;
};

export const LocationDisplayCell: React.FC<LocationDisplayCellProps> = ({
  event,
  performer,
  venue,
  isSinglePerformerView,
}) => {
  const lowerCasedEventName = event.name.toLocaleLowerCase();
  const lowerCasedPerformer = performer?.name?.toLocaleLowerCase();
  const doNotShowVenue =
    event.genre === TopLevelCategory.Sports && isSinglePerformerView;
  const displayVenueOnly =
    isSinglePerformerView &&
    (event.genre === TopLevelCategory.Concert ||
      event.genre === TopLevelCategory.Theatre) &&
    lowerCasedEventName === lowerCasedPerformer;

  const descr = getDescription(venue);
  return (
    <TableCellDiv align="left" className={styles.basicFont}>
      {(!doNotShowVenue || displayVenueOnly) && (
        <VenueNameDisplay venueLocation={descr} slimMode />
      )}
    </TableCellDiv>
  );
};
